import request from '@/utils/request'
import host from '@/api/base/host'

// 订单模块
const coupon = host.path('dev', { module: 'coupon', dev: 'v1/home' }) // 开发地址:ljs

export default {
  // 获取内容团队成员详情
  courseTeamTeacher(data) {
    console.log('data--------', data)
    return request({ url: coupon('courseTeam/teacher/main'), method: 'post', data })
  }
}
